import React from "react"
export function UaeFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__UAE"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__uae" fillRule="nonzero">
          <path
            id="prefix__Rectangle"
            stroke="#CCC"
            strokeWidth={0.5}
            fill="#FFF"
            d="M.45 4.95h23.3v6.5H.45z"
          />
          <path id="prefix__Rectangle" fill="#007934" d="M0 .1h24v5.4H0z" />
          <path id="prefix__Rectangle" fill="#000" d="M0 10.6h24V16H0z" />
          <path id="prefix__Rectangle" fill="#D52B1E" d="M0 .1h6.4V16H0z" />
        </g>
      </g>
    </svg>
  )
}
